module.exports = __webpack_public_path__ + "static/media/partner01.cc4f8c9e.svg";